import { Component, ElementRef, Inject} from "@angular/core";
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from "@angular/router";
import * as jQuery from "jquery";
import { DataService } from '../../../services/data/data.service';
import { TradeRequestModel } from '../../../model/trade.request.data';
import { Ticket } from '../../tradedeskTabs/orders/tradeskOrdersTab/tradeskOrdersTab.component';
import { Workspace } from '../../../model/workspace.data';
import {tradeDeskTabsList} from "../../tradedeskTabs/tradedeskTabs.list";


@Component({
    selector: "modal-orderdelete",
    template: require('./orderdelete.component.html'),
    styles: [require('./orderdelete.component.css')]
})

export class OrderDeleteModal {

    
   private _orderRowData:any;

  public set orderRowData(v:any)
  {
      this._orderRowData=v;
    //  alert(this.orderRowData.id)
  }

  public get orderId()
  {
      return this.orderRowData.Ticket;
  }

  public get orderRowData():any{
      return this._orderRowData;
  }

  public get symbol(): string
  {
      return this.orderRowData && this.orderRowData.Symbol || '';
  }

  public get isCancelable()
  {
    if(this.workspace)
    {
        if(this.workspace.activeTradeDeskTab == tradeDeskTabsList.ORDERS)
        {
           // this.dataService.sendRequest({ Cmd: DataService.TYPE_CLOSETRADE, Data: ticketData });
           return false
        }

        if(this.workspace.activeTradeDeskTab == tradeDeskTabsList.ORDERS_PENDING)
        {
            return true
           // this.dataService.sendRequest( { Cmd: DataService.TYPE_CANCELTRADE, Data: ticketData } );
        }
    }



      return (this.orderRowData && this.orderRowData.MenuRequests && this.orderRowData.MenuRequests.indexOf( "CancelReq" ) > -1 ) ? true : false;
  }
    constructor(
        private router: Router,
        private fb: FormBuilder,
        public activeModal: NgbActiveModal,
        private dataService: DataService,
      //  public orderDeleteData:deleteOrderRequest
    ) {

    }

    public hideButtons(){}


   public deleteOrder()
    { 
        this.sendDeleteRequest();
        this.hideButtons();
        this.activeModal.close();
       
    }

    public workspace?:Workspace
    
    private _currentRequestId:string="";
    
    sendDeleteRequest():void
    {
        let ticketData: Ticket = { Ticket:  this.orderRowData.Ticket };

        if(this.workspace)
        {
            if(this.workspace.activeTradeDeskTab == tradeDeskTabsList.ORDERS)
            {
                this.dataService.sendRequest({ Cmd: DataService.TYPE_CLOSETRADE, Data: ticketData });
                return
            }

            if(this.workspace.activeTradeDeskTab == tradeDeskTabsList.ORDERS_PENDING)
            {
                this.dataService.sendRequest( { Cmd: DataService.TYPE_CANCELTRADE, Data: ticketData } );
                return
            }
        }



        if(this.isCancelable)
        {
            this.dataService.sendRequest( { Cmd: DataService.TYPE_CANCELTRADE, Data: ticketData } );
            return;
        }

        this.dataService.sendRequest({ Cmd: DataService.TYPE_CLOSETRADE, Data: ticketData });
    }

    public get allowDeleteOrder()
    {
        if(this.isCancelable)
            return true;

        if(this.oldestOrder == "NOCHALLENGE")
        {
            return true;
        }
        
        return this.oldestOrder == this.orderRowData.Ticket;
    }



    private _oldestOrder: string = "";
    public get oldestOrder (): string {
        return this._oldestOrder;
    }
    public set oldestOrder ( value: string ) {
        this._oldestOrder = value;
    }

}

export function ShowOrderDeleteModal(modalService: NgbModal, orderData:any, oldestOrder:string, workspace?:Workspace){
    let m:NgbModalRef= modalService.open(OrderDeleteModal,{
        backdrop: "static",
        size: "sm",
        centered: true, 
        windowClass: "dark-modal"
    });
    let modal = (<OrderDeleteModal>m.componentInstance);
    modal.orderRowData = orderData;
    modal.oldestOrder = oldestOrder;

    modal.workspace = workspace

}
//{"Cmd":"cxl","Symbols":[],"CXL":{"ClOrdId":"201808051000085"}}
export interface deleteOrderRequest
{
    Cmd:string,
    Symbols:string[],
    CXL:{
        ClOrdId:string
    }
}

